const FADE_TRANSITION_DURATION = 100;
const buttonCls = "_086b1f0d2pl";

export { FADE_TRANSITION_DURATION, buttonCls };
import "./Line.style.linaria.module.css";
//# sourceMappingURL=Line.style.js.map
